import {Params, useFetchGet} from 'helpers/api'
import {useEffect, useState} from 'react'
import {paginationDefaults} from 'helpers/style'
import RailGatewayStatusTable from './rail-gateway-status-table'
import {Collapse} from 'antd'
const {Panel} = Collapse

export const RailGatewayStatus = ({query}) => {
  const [meta, setMeta] = useState()
  const [data, setData] = useState()
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [activeKey, setActiveKey] = useState(0) // Controls which panel is open

  const handleChange = key => {
    // Toggle the panel: if the same key is clicked again, close it
    setActiveKey(activeKey === key ? null : key)
  }

  const fetchRailgwstatusview = useFetchGet('railgwstatus')

  const getRailGWStatus = () => {
    const params = Params({...query, limit, page})
    fetchRailgwstatusview(params, response => {
      console.log('RailGatewayStatus response', response)
      setMeta(response.meta)
      setData(response.railgwstatus)
    })
  }

  useEffect(() => {
    if (query?.gid) getRailGWStatus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, page, limit]) // 👈 add page and limit here

  if (!data) {
    return <></>
  } else {
    return (
      <Collapse defaultActiveKey={[]} style={{marginTop: 16}}>
        <Panel header="Status Details" key="1">
          <RailGatewayStatusTable
            data={data}
            pagination={paginationDefaults(meta.total, limit, setLimit, page, setPage)}
          />
        </Panel>
      </Collapse>
    )
  }
}
